import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { getAllArticulos } from '../../actions/tipo_articulos_actions';
import { modifyProductoCajaDeZona, addProductoCajaDeZona, removeProductoCajaDeZona } from '../../actions/zona_productos_caja_actions';
import {
    openDialog, hideDialog, setSaveState
} from '../../actions';


const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});



class ZonaProductosCaja extends React.Component {


    modifyProductoCaja = (producto) => {
        this.props.setSaveState(true);
        this.props.modifyProductoCajaDeZona(producto);
    };

    addProductoCaja = (producto) => {
        this.props.setSaveState(true);
        this.props.addProductoCajaDeZona(producto);
    };

    messageError = (error) => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkProductoCaja = (producto) => {

        if (this.props.zonaProductosCaja.find(p => (p.descr === producto.descr) && (p.id !== producto.id))) {
            this.messageError(`Ya existe un producto de caja ${producto.descr}`);
            return false;
        }

        else return true;

    };


    editProductCaja = (producto) => {

        this.props.openDialog('EditZonaProductCaja', {
            producto: producto,
            zonaProductosCaja: this.props.zonaProductosCaja,
            allproductos: this.props.allproductos,
            tipoZonaIva: this.props.tipoZonaIva,
            elemCajaId: this.props.elemCajaId,
            okHandler: this.modifyProductoCaja,
            checkProductoCaja: this.checkProductoCaja
        }, uuidv4());
    };

    newProductCaja = () => {

        this.props.openDialog('EditZonaProductCaja', {
            producto: {},
            zonaProductosCaja: this.props.zonaProductosCaja,
            allproductos: this.props.allproductos,
            tipoZonaIva: this.props.tipoZonaIva,
            elemCajaId: this.props.elemCajaId,
            okHandler: this.addProductoCaja,
            checkProductoCaja: this.checkProductoCaja
        }, uuidv4());

    };

    removeProductCaja = (producto, index) => {
        this.props.setSaveState(true);
        this.props.removeProductoCajaDeZona(producto);
    };



    render() {

        const { classes } = this.props;


        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Conceptos de Caja</Typography>

                {this.props.zonaProductosCaja && !this.props.isLoading ?
                <NeuriteGrid
                id="z_p_c"
                    columns={[
                        { key: 'descr', name: 'Tipo Cobro', editable: false, dragable: false, width: 140 },
                        { key: 'ctaDebe', name: 'Debe', editable: false, dragable: false, width: 75 },
                        { key: 'ctaHaber', name: 'Haber', editable: false, dragable: false, width: 75 },
                        { key: 'ctaIva', name: 'IVA', editable: false, dragable: false, width: 75 },
                        { key: 'tipoZonaIva', name: 'Tipo Zona IVA', editable: false, dragable: false, width: 100 },
                        { key: 'activo', name: 'Activo', editable: false, dragable: false, type: 'bool', width: 55 },
                    ]}
                    rows={this.props.zonaProductosCaja}
                    buttonEdit={true}
                    buttonDelete={true}
                    buttonNew={this.props.elemCajaId !== -1 ? true : false}
                    onNewRowClick={this.newProductCaja}
                    onEditClick={this.editProductCaja}
                    onDeleteClick={this.removeProductCaja}
                    height={200}
                />
                : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}

            </div>
        );

    };

};

ZonaProductosCaja.propTypes = {
    //state
    zonaProductosCaja: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    allproductos: PropTypes.array.isRequired,
    elemCajaId: PropTypes.number,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getAllArticulos: PropTypes.func.isRequired,
    modifyProductoCajaDeZona: PropTypes.func.isRequired,
    addProductoCajaDeZona: PropTypes.func.isRequired,
    removeProductoCajaDeZona: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        zonaProductosCaja: state.zonaProductosCaja.productosCaja,
        isLoading: state.zonaProductosCaja.isLoading,
        allproductos: state.allArticulos,
        tipoZonaIva: state.tipoZonaIva,
        elemCajaId: state.zonaDetalles.zona.elemCajaId
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        getAllArticulos,
        modifyProductoCajaDeZona,
        addProductoCajaDeZona,
        removeProductoCajaDeZona,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ZonaProductosCaja));
